export default __webpack_public_path__ + "static/media/12.300d2119.jpg";